<template>
  <div class="img">
    <img :src="img" />
  </div>
</template>
<script>
export default {
  name: "list",
  data() {
    return {
      img: '',
      openId: ''
    };
  },
  mounted() {
    this.openId = this.$route.query.openId;
    this.img = this.$route.query.img;
    this.getTitle();

  },
  methods: {

    async getTitle() {
      let auth =this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getTitle,{
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      })
      if(result.message==='Error: Miss auth parameter.'){
        this.getTitle();
      } else {
        document.title = result.data?.title
      }
    },
  }
};
</script>
<style scope lang="less">
.img {
  position: absolute;
  top: 25%;
  width: 100%;
  text-align: center;
  img {
    width: 3rem;
    height: 3rem;
  }
}
</style>
